import { useFile, useSelection, useVisualizer, useUI } from '../../context/AppContext.jsx';

export default function FeaturesSection() {
  const { currentFeatures, setCurrentFeatures, installationParser } = useFile();
  const { selectedFeatureIndex, setSelectedFeatureIndex } = useSelection();
  const { visualizer } = useVisualizer();
  const { showStatus } = useUI();

  if (!currentFeatures || currentFeatures.length === 0) return null;

  const handleAddFeature = () => {
    try {
      // Generate default name: "Feature_1", "Feature_2", etc.
      const featureNumber = currentFeatures.length; // This includes Base, so first user feature will be Feature_1
      const defaultName = `Feature_${featureNumber}`;

      const newFeature = installationParser.createFeature(defaultName);
      const updatedFeatures = [...currentFeatures, newFeature];
      setCurrentFeatures(updatedFeatures);

      // Update visualizer
      if (visualizer) {
        visualizer.visualizeFeatures(updatedFeatures);
      }

      // Select the newly created feature for editing
      setSelectedFeatureIndex(updatedFeatures.length - 1);

      showStatus(`Feature "${defaultName}" created successfully`, 'success');
    } catch (error) {
      showStatus(`Failed to create feature: ${error.message}`, 'error');
    }
  };

  return (
    <section className="mb-6">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-lg font-semibold">Features</h2>
        <button
          onClick={handleAddFeature}
          className="bg-primary text-white px-2 py-1 text-xs rounded hover:bg-blue-600 transition-colors"
          title="Add new feature"
        >
          + Add
        </button>
      </div>
      <p className="text-text-secondary text-sm mb-4">
        {currentFeatures.length} feature{currentFeatures.length !== 1 ? 's' : ''} loaded
      </p>
      
      <div className="space-y-1">
        {currentFeatures.map((feature, index) => (
          <div
            key={index}
            className={`p-2 rounded cursor-pointer transition-colors ${
              selectedFeatureIndex === index 
                ? 'bg-primary bg-opacity-20 border border-primary' 
                : 'hover:bg-bg-hover'
            }`}
            onClick={() => setSelectedFeatureIndex(index)}
          >
            <div className="text-text-primary text-sm font-medium">
              {feature.name || `Feature ${index + 1}`}
            </div>
            <div className="text-text-secondary text-xs mt-1">
              X: {(feature.position.x * 1000).toFixed(1)}mm, Y: {(feature.position.y * 1000).toFixed(1)}mm, Z: {(feature.position.z * 1000).toFixed(1)}mm
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}


